module.exports = __webpack_public_path__ + "static/media/cab-q12.0a93ebd4.jpg";